import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import React, {useRef, useState} from "react"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"

// components
import AmenitiesLangs from "./_langs";
import Separator from "../../../../../src/components/Separator";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";

// labels
import {PH_CODE, PH_ICON,} from "../../../../components/i18n/placeHolders"
import {FORM, LB_CODE, INTERNATIONAL, REQUIRED, LB_ICON} from "../../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";
import {FL_CATEGORY, FL_TYPE_AMENITY} from "../../../../components/i18n/formLabels";

// services
import {roomAmenityService} from "../../../../jwt/_services/hotel/roomAmenityService"
import {amenityService} from "../../../../jwt/_services/hotel/amenityService";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// providers
import {hotelCategoryProvider} from "../../../../providers/hotelCategoryProvider";
import {amenityTypeProvider} from "../../../../providers/amenityTypeProvider";

// utils
import {getStateByPath} from "../../../../redux/selectors";


const AmenitiesForm = props => {
    const roomTypeState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject:roomType, app } = roomTypeState?.data || {};

    const path = `${props.path}/amenities`;
    const componentState = useSelector(state => getStateByPath(state, path));
    const { editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}
    const translatableLangs = domainObject?.translatedLangs || []

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)

    const [amenityType, setAmenityType] = useState(domainObject?.type?.id);
    const [categoryId, setCategoryId] = useState(domainObject?.category?.id);

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            icon: domainObject?.icon,
        }
    });


    const onSubmit = async (data, _) => {
        let amenityRequest = {
            fbDataBase,
            item : {
                ...data,
                langs,
                category : (!categoryId) ? null : { id: categoryId },
                type : (!amenityType) ? null : { id: amenityType },
            }
        };

        props.setLoading(path, true);

        if(editMode){
            amenityRequest.item.id = domainObject?.id
            await amenityService.updateItem(domainObject?.id, amenityRequest) // actualizar la amenidad
                .then(() => {
                    closeForm()
                    })
                .catch((error) => {
                    props.setLoading(path, false);
                });
            return
        }

        const amenityResponse = await amenityService.saveItem(amenityRequest) // guardar la amenidad

        const requestData = {
            fbDataBase,
            item: {
                status:true,
                roomType: { id: roomType.id },
                amenity: { id: amenityResponse?.id }
            }
        }

        genericIndexedActions.save(path, roomAmenityService, requestData, closeForm) // vincular la amenidad con el tipo de habitación
    };

    const closeForm = () => {
        reset();
        props.setLoading(path, false);
        props.toggle()
    }


    return <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        keyboard={false}
        modalClassName="menu-modal-form"
    >
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>{FORM}
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                />
                                {errors.code && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>{LB_ICON}</Label>
                                <Input
                                    type="text"
                                    name="icon"
                                    placeholder={PH_ICON}
                                    innerRef={register}
                                />
                                {errors.icon && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.icon?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{ FL_CATEGORY }</Label>
                                <SelectGeneric
                                    initialValue={categoryId}
                                    setExternalValue={setCategoryId}
                                    provider={hotelCategoryProvider}
                                    getAllCategories={true}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>{ FL_TYPE_AMENITY }</Label>
                                <SelectGeneric
                                    initialValue={amenityType}
                                    setExternalValue={setAmenityType}
                                    provider={amenityTypeProvider}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        {INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <AmenitiesLangs
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                </CardBody>
                {
                    showModal && <LogHistoryModal
                        ref={modalRef}
                        item={domainObject}
                    />
                }
            </Card>
        </Form>
    </Modal>
}
export default AmenitiesForm